/*
 * General custom scripts
 */
import './front/navigation';

